import { SummaryMessageUnit } from 'generated/graphql';
import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';
import { EntityLabel } from 'v2/core/entities/feedback/labels';
import { UUID } from 'v2/core/entities/uuid';

export const generateKeywordSummaryUnitsMap = (
  feedbackLabels: FeedbackLabel[],
) => {
  const keywordSummaryUnitsMap = new Map<UUID, SummaryMessageUnit[]>();

  const keywordLabels = feedbackLabels.filter(
    (label): label is EntityLabel => label.type === FeedbackLabelType.Entity,
  );

  if (!keywordLabels.length) {
    return keywordSummaryUnitsMap;
  }

  keywordLabels.forEach((label) => {
    if (label.keywordSummary?.units?.length) {
      keywordSummaryUnitsMap.set(label.id, label.keywordSummary.units);
    }
  });

  return keywordSummaryUnitsMap;
};
